import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import { ButtonLoader, Input, Checkbox } from "components/__new/common/form";
import { ReactComponent as IconAngleLeft } from "assets/images/icons/project-icons/angle-left.svg";
import ComplianceHeader from "components/__new/compliance/ComplianceHeader";
import useBackButton from "hooks/useBackButton";
import useLoginInfo from "hooks/useLoginInfo";
import PageContent from "components/__new/common/PageContent";
import Maybe from "components/__new/common/Maybe";
import { maskPhoneNumber } from "utils/maskData";
// import moment from "moment";
import validate from "utils/validate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
import * as complianceActions from "store/entities/compliance/action";
import * as bvnActions from "store/ui/bvn/action";
import * as accountActions from "store/auth/account/action";


const VerifyBvn = () => {
    const history = useHistory();
    const {goBack} = useBackButton();
    const dispatch = useDispatch();
    const {userInfo} = useLoginInfo();
    const { savedBvnInfo } = useSelector((s) => s.entities.compliance);
    const { bvnValidationLoading, bvnValidation, bvnOtpLoading, bvnOtp } = useSelector((s) => s.ui.bvn);
    const { employerInfoLoading, employerInfo, companyInfoUpdateLoading, companyInfoUpdate, profileUpdateLoading, profileUpdated } = useSelector((s) => s.auth.account);
    
    
    const [isFormValidated, setIsFormValidated] = useState(false);
    const [showBvnValidationResponse, setShowBvnValidationResponse] = useState(false);
    const [form, setForm] = useState({
        bvn: "",
        phoneNumber: savedBvnInfo.phoneNumber ?? "",
    })
    
    
    const getEmployerInfo = () => {
        if(!employerInfoLoading && (Object.keys(employerInfo).length === 0 || employerInfo.status !== "success")){
            dispatch(accountActions.getEmployerInfo())
        }
    }
    
    
    const checkFormValidation = (data = form, appendKey, appendValue) => {
        let params = {...data};
        if (appendKey){
            params = {
                ...params,
                [appendKey]: appendValue,
            };
        }
        delete params["phoneNumber"];
        const errors = validate(params);
        if (errors){
            setIsFormValidated(false);
            // console.log("checkFormValidation", errors);
        }
        else{
            setIsFormValidated(true);
        }
    }
    
    
    const fetchBvnInfo = (e) => {
        if (e !== "" && e.length === 11){
            dispatch(bvnActions.validateBvn({
                bvn: e,
                // dob: moment(companyInfo?.dob).format("DD-MM-YYYY"),
            }, userInfo.token));
            
            if (showBvnValidationResponse !== true){
                setShowBvnValidationResponse(true);
            }
        }
        else{
            if (showBvnValidationResponse !== false){
                setShowBvnValidationResponse(false);
            }
        }
        
        if (form.phoneNumber !== ""){
            setForm({...form, phoneNumber: ""});
        }
    }
    
    
    const submitForm = async (e, exit=true) => {
        e?.preventDefault();
        dispatch(complianceActions.saveBvnInfo(form));
        
        const params = { bvn: form.bvn }
        dispatch(accountActions.updateCompanyInfo(params));
    }
    
    
    const getDisabledStatus = () => {
        if (employerInfoLoading === true || bvnValidationLoading === true || form.phoneNumber === "" || companyInfoUpdateLoading === true || isFormValidated === false){
            return true;
        }
        return false;
    }
    
    
    useEffect(() => {
        const {isCompliant, status} = userInfo.employer;
        
        if (isCompliant === true){
            history.push("/compliance/approval/success");
        }
        else if (isCompliant === false && status === "review"){
            history.push("/compliance/unregistered/approval");
        }
        else{
            dispatch(complianceActions.updateComplianceProgress(50));
            dispatch(complianceActions.saveBvnInfo({}));
            getEmployerInfo();
        }
        // eslint-disable-next-line
    }, [])
    
    
    useEffect(() => {
        if (employerInfoLoading === false && employerInfo.status === "success"){
            const data = {
                ...form,
                bvn: employerInfo?.data?.employer?.company?.bvn ?? "",
            }
            setForm(data);
            checkFormValidation(data);
            if (data.phoneNumber === ""){
                fetchBvnInfo(data.bvn);
            }
        }
        // eslint-disable-next-line
    }, [employerInfoLoading, employerInfo])
    
    
    useEffect(() => {
        if (companyInfoUpdate.status === "success"){
            dispatch(accountActions.resetUpdateCompanyInfo());
            dispatch(accountActions.updateEmployerInfoFE(companyInfoUpdate?.data));
            dispatch(bvnActions.sendBvnOtp(form, userInfo.token));
        }
        // eslint-disable-next-line
    }, [companyInfoUpdate])
    
    
    useEffect(() => {
        if (bvnValidation.status === "failed"){
            if (bvnValidation?.statusCode === "000"){
                dispatch(bvnActions.resetValidateBvn());
                dispatch(complianceActions.saveBvnInfo({}));
                dispatch(accountActions.updateProfile({
                    firstName: userInfo?.employer?.firstName ?? "",
                    lastName: userInfo?.employer?.lastName ?? "",
                    phoneNumber: userInfo?.employer?.phoneNumber ?? "",
                    jobTitle: userInfo?.employer?.jobTitle ?? "",
                    email: userInfo?.employer?.email ?? "",
                    status: "review",
                }));
            }
            else{
                toast.error(bvnValidation.message);
            }
        }
        // eslint-disable-next-line
    }, [bvnValidation])
    
    
    useEffect(() => {
        if (profileUpdated?.status === "success"){
            dispatch(accountActions.resetUpdateProfile());
            dispatch(accountActions.getEmployerInfo());
            history.push("/compliance/unregistered/approval");
        }
        // eslint-disable-next-line
    }, [profileUpdated])
    
    
    useEffect(() => {
        if (bvnOtp.status === "success"){
            dispatch(bvnActions.resetSendBvnOtp());
            history.push("/compliance/unregistered/verify-bvn-otp");
        }
        // eslint-disable-next-line
    }, [bvnOtp])
    
    
    return (
        <div>
            
            <DynamicHeadTag
                headerText="Earnipay Compliance"
                headerDescription="Complete each step to access all Earnipay features"
            />
            
            <ComplianceHeader />
            
            <div className="pt-6 px-6 pb-24 sm:pt-10 sm:px-10">
                <div className="max-w-2xl mx-auto box">
                    
                    <div className="flex justify-start">
                        <div onClick={goBack} className="w-max h-8 pr-2 mr-1 flex items-center cursor-pointer">
                            <IconAngleLeft style={{ height: "16px" }} className="w-max pr-3 m-auto" />
                            Back
                        </div>
                    </div>
                    
                    <div className="pb-2 mt-8 border-b">
                        <div className="font-bold text-xl">
                            BVN Verfication
                        </div>
                        <div className="text-fade text-sm">
                            Please fill in the details to verify your identity
                        </div>
                    </div>
                        
                        
                    <PageContent
                        loading={employerInfoLoading}
                        data={employerInfo}
                        loadingText="Fetching business information..."
                        emptyText="Business information not found"
                        errorText="Unable to fetch business information"
                    />

                    <Maybe condition={employerInfoLoading === false && employerInfo?.status === "success"}>
                        <Maybe condition={profileUpdateLoading === true}>
                            <div className="mt-4 px-4 py-2 text-center flex items-center bg-ep-secondary-400 bg-opacity-30">
                                <FontAwesomeIcon icon="spinner" spin className="mr-2" />
                                Please wait...
                            </div>
                        </Maybe>
                        
                        
                        <form onSubmit={submitForm} className="mt-8">
                            <Input type="number" label="BVN" required={true} disabled={bvnValidationLoading === true} value={form.bvn} onKeyUp={(e) => fetchBvnInfo(e.target.value)} onChange={(e) => setForm({...form, bvn: e.target.value})} validationName="bvn" checkFormValidation={checkFormValidation} />
                            
                            <Maybe condition={showBvnValidationResponse === true}>
                                <div className="-mt-3.5 form-input-message">
                                    <Maybe condition={bvnValidationLoading === true}>
                                        <div className="!text-black">
                                            <FontAwesomeIcon icon="circle-notch" spin className="mr-1" />
                                            Verifying
                                        </div>
                                    </Maybe>
                                    <Maybe condition={bvnValidationLoading === false && bvnValidation?.status !== "success"}>
                                        <div>
                                            <Maybe condition={bvnValidation.message === "Bvn details mismatch"}>
                                                BVN details mismatch: please update your&nbsp;
                                                <Link to="/settings/profile" className="underline">name</Link> or&nbsp;
                                                <Link to="/compliance/unregistered/verify-business" className="underline">date of birth</Link>
                                            </Maybe>
                                            <Maybe condition={bvnValidation.message !== "Bvn details mismatch"}>
                                                {bvnValidation.message}
                                            </Maybe>
                                        </div>
                                    </Maybe>
                                    <Maybe condition={bvnValidationLoading === false && bvnValidation?.status === "success"}>
                                        <div className="!text-green-500">
                                            Verified
                                        </div>
                                    </Maybe>
                                </div>
                            </Maybe>
                            
                            <Maybe condition={bvnValidationLoading === false && bvnValidation?.status === "success" && form.bvn.length === 11}>
                                <div className="mt-6 text-sm mb-1">
                                    Please select a phone number
                                    <span className="form-input-required">*</span>
                                </div>
                                
                                {bvnValidation?.data?.phoneNumbers?.map((phoneNumber, index) => (
                                    <div key={index} onClick={() => setForm({...form, phoneNumber: phoneNumber})}
                                        className={`box px-4 py-3 mb-2 flex space-x-2 items-center border ${form.phoneNumber === phoneNumber ? "bg-[#EBF5F9] border-ep-primary":"border-gray-200" } cursor-pointer`}>
                                        <div>
                                            <Checkbox
                                                type="radio"
                                                label=""
                                                checked={form.phoneNumber === phoneNumber}
                                                readonly={true}
                                            />
                                        </div>
                                        <div>
                                            {maskPhoneNumber(phoneNumber)}
                                        </div>
                                    </div>
                                ))}
                            </Maybe>
                            
                            <div className="mt-8 flex justify-end space-x-4">
                                <ButtonLoader type="submit" loading={bvnOtpLoading === true} className="btn btn-ep-primary" disabled={getDisabledStatus() === true}>
                                    Continue
                                </ButtonLoader>
                            </div>
                            
                        </form>
                    </Maybe>
                    
                </div>
            </div>
            
        </div>
    )
}


export default VerifyBvn;